<template>
  <div class="shell-page">
    <section class="invitation-shell">
      <div class="glass-surface invitation-card">
        <div class="invitation-card__logo">
          <img src="/static/FOMOPLANES_isotipo_512.png" alt="Fomo Planes" />
        </div>

        <div class="invitation-card__copy">
          <span class="invitation-card__micro">Powered by Fomo Planes</span>
          <h1 class="invitation-card__title">{{ invitationTitle }}</h1>
          <p class="invitation-card__text">{{ invitationSubtitle }}</p>
          <p class="invitation-card__text">{{ invitationDescription }}</p>
        </div>

        <div class="d-flex justify-content-center" style="gap: 12px; flex-wrap: wrap;">
          <button class="btn btn-primary" type="button" @click="goToEvent">Ver experiencia</button>
          <a class="btn btn-outline-light" href="https://www.fomoplanes.com">www.fomoplanes.com</a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { apiService } from '../common/api.services.js'

export default {
  name: 'InvitationView',

  props: {
    id: {
      required: true,
    },
  },

  data() {
    return {
      event: {},
      venue: {},
      city: '',
    }
  },

  computed: {
    invitationTitle() {
      return this.event.name ? `${this.event.name}` : 'Tu invitacion exclusiva ya esta lista'
    },

    invitationSubtitle() {
      if (!this.event.name) {
        return 'Accede a una experiencia privada con una presentacion mas sobria y directa.'
      }

      return `${this.venue.name || 'Venue por confirmar'}${this.city ? ` · ${this.city}` : ''}`
    },

    invitationDescription() {
      return this.event.description || 'Estas a un paso de descubrir un evento presentado con una estetica mas elegante y un flujo visual pensado para sorprender.'
    },
  },

  created() {
    this.getEvent()
  },

  methods: {
    getEvent() {
      apiService(`/api/events/${this.id}/`).then((data) => {
        this.event = data
        this.venue = data.venue || {}
        this.city = data.venue && data.venue.city ? data.venue.city.name : ''
      })
    },

    goToEvent() {
      if (this.event.slug) {
        this.$router.push({ name: 'event', params: { slug: this.event.slug } })
      }
    },
  },
}
</script>

<style>
</style>
